import React from 'react';
import '../styles/ChatFloatingButton.css';

const ChatFloatingButton = ({ onClick, title = 'Chat', isActive = false, unreadCount = 0 }) => {
  const showUnreadBadge = Number(unreadCount) > 0;
  const unreadLabel = Number(unreadCount) > 99 ? '99+' : String(unreadCount);

  return (
    <div className="top-right-chat-button-container">
      <button
        type="button"
        className={`chat-floating-btn ${isActive ? 'active' : ''}`}
        onClick={onClick}
        title={title}
        aria-label={title}
        aria-pressed={isActive}
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z"></path>
        </svg>
        {showUnreadBadge && (
          <span className="chat-floating-unread-dot" aria-label={`${unreadLabel} unread messages`}>
            {unreadLabel}
          </span>
        )}
      </button>
    </div>
  );
};

export default ChatFloatingButton;
